import AppBar from '@material-ui/core/AppBar';
import { publicLogoPath } from '@orientaction/utils';
import { FC } from 'react';
import useStyles from './style';

const ShareFixedHeader: FC = () => {
  const classes = useStyles();

  return (
    <>
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <div className={classes.inner}>
          <div className={classes.logoContainer}>
            <picture>
              <source srcSet={`${publicLogoPath}/e-orientaction.png`} />
              <img
                src={`${publicLogoPath}/e-orientaction.png`}
                alt="E-Orientaction"
                className={classes.logoImg}
              />
            </picture>
          </div>
        </div>
      </AppBar>
      <div className={classes.spacer} />
    </>
  );
};

export default ShareFixedHeader;
